export interface WorldRecordsContainerState {
  default: string;
}

export interface WorldEvent {
  id?: string;
  name: string;
  subCategory?: null | string;
  sportGroup?: {
    id: string;
    name: string;
  };
  sportGroupId?: string;
  input: WorldRecordType;
}

export interface WorldRecord {
  id?: string;
  event: WorldEvent;
  eventId: string;
  topTimeSecMen: number;
  topTimeSecWomen: number;
  topDistanceMeterMen: number;
  topDistanceMeterWomen: number;
  topPointsMen: number;
  topPointsWomen: number;
  topRankMen: number;
  topRankWomen: number;
  men: number;
  women: number;
}

export enum WorldRecordType {
  Distance = 1,
  Time = 2,
  Rank = 3,
  Points = 4,
}

export enum WorldRank {
  Recreation = 1,
  Junior = 2,
  Regional = 3,
  National = 4,
  International = 5,
}

